import {
  getLpuRequestInterface,
  getDoctorRequestInterface,
  getServicesRequestInterface,
  getDoctorOnlineRequestInterface,
} from 'www/modules/Schedule/models'

import { PAGE_TYPE_DATA } from 'www/modules/Schedule/constants'
import type {
  LpuRequestInterface,
  DoctorRequestInterface,
  ServicesRequestInterface,
  DoctorOnlineRequestInterface,
} from 'www/modules/Schedule/models/request'

type PageType = typeof PAGE_TYPE_DATA[keyof typeof PAGE_TYPE_DATA]

type RequestDataInterface =
  | LpuRequestInterface
  | DoctorRequestInterface
  | DoctorOnlineRequestInterface
  | ServicesRequestInterface

/**
 * @description
 * Возвращает нужный интерфейс запроса за расписанием в зависимости от переданных аргументов
 *
 * @param opts.pageType - одна из констант 'PAGE_TYPE_DATA'
 * @param opts.isDoctorOnline - если pageType === 'doctors', то может быть онлайн город или выбран фильтр по месту онлайн.
 * Если это так - должен вернуться другой интерфейс запроса расписания для врачей.
 *
 * @returns один из интерфейсов - 'getLpuRequestInterface' | 'getDoctorRequestInterface' | 'getDoctorOnlineRequestInterface' | 'getServicesRequestInterface'
 */

const getRequestDataInterface = ({
  pageType,
  isDoctorOnline = false,
}: {
  pageType: PageType
  isDoctorOnline?: boolean
}): RequestDataInterface | undefined => {
  switch (pageType) {
    case PAGE_TYPE_DATA.lpu:
      return getLpuRequestInterface()
    case PAGE_TYPE_DATA.doctors:
    case PAGE_TYPE_DATA.doctorsLpu:
      return isDoctorOnline ? getDoctorOnlineRequestInterface() : getDoctorRequestInterface()
    case PAGE_TYPE_DATA.services:
      return getServicesRequestInterface()
    default:
      return undefined
  }
}

export default getRequestDataInterface
